import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { SearchInput } from '../../components/ui/Input';
import { Building2, Mail, Calendar, MoreHorizontal, UserPlus, X } from 'lucide-react';
const users = [{
  id: 1,
  name: 'John Doe',
  email: 'john@excelhomes.com',
  role: 'Builder Admin',
  builder: 'Excel Homes',
  builderId: 1,
  status: 'Active',
  lastActive: '2 hours ago',
  joinedDate: '2023-06-15'
}, {
  id: 2,
  name: 'Sarah Johnson',
  email: 'sarah@excelhomes.com',
  role: 'Builder Employee',
  builder: 'Excel Homes',
  builderId: 1,
  status: 'Active',
  lastActive: '1 day ago',
  joinedDate: '2023-08-20'
}, {
  id: 3,
  name: 'Michael Chen',
  email: 'michael@schellbrothers.com',
  role: 'Builder Admin',
  builder: 'Schell Brothers',
  builderId: 2,
  status: 'Active',
  lastActive: '30 mins ago',
  joinedDate: '2023-03-22'
}, {
  id: 4,
  name: 'Emily Rodriguez',
  email: 'emily@mattamyhomes.com',
  role: 'Builder Admin',
  builder: 'Mattamy Homes',
  builderId: 3,
  status: 'Active',
  lastActive: '5 hours ago',
  joinedDate: '2022-11-10'
}, {
  id: 5,
  name: 'David Park',
  email: 'david@landmarkhomes.com',
  role: 'Builder Employee',
  builder: 'Landmark Homes',
  builderId: 4,
  status: 'Active',
  lastActive: '2 days ago',
  joinedDate: '2024-01-10'
}, {
  id: 6,
  name: 'Lisa Thompson',
  email: 'lisa@starwardhomes.com',
  role: 'Builder Admin',
  builder: 'Starward Homes',
  builderId: 5,
  status: 'Active',
  lastActive: '1 hour ago',
  joinedDate: '2023-09-08'
}, {
  id: 7,
  name: 'Rohit Patel',
  email: 'rohit@rohit.com',
  role: 'Builder Admin',
  builder: 'Rohit',
  builderId: 6,
  status: 'Inactive',
  lastActive: '2 weeks ago',
  joinedDate: '2023-11-30'
}];
const buildersList = [{
  id: 1,
  name: 'Excel Homes'
}, {
  id: 2,
  name: 'Schell Brothers'
}, {
  id: 3,
  name: 'Mattamy Homes'
}, {
  id: 4,
  name: 'Landmark Homes'
}, {
  id: 5,
  name: 'Starward Homes'
}, {
  id: 6,
  name: 'Rohit'
}];
const builders = ['All Builders', 'Excel Homes', 'Schell Brothers', 'Mattamy Homes', 'Landmark Homes', 'Starward Homes', 'Rohit'];
export function UsersPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBuilder, setSelectedBuilder] = useState('All Builders');
  const [roleFilter, setRoleFilter] = useState('All Roles');
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    builderId: '',
    role: ''
  });
  const filteredUsers = users.filter(user => {
    const matchesSearch = user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesBuilder = selectedBuilder === 'All Builders' || user.builder === selectedBuilder;
    const matchesRole = roleFilter === 'All Roles' || user.role === roleFilter;
    return matchesSearch && matchesBuilder && matchesRole;
  });
  // ESC key handler
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && showAddUserModal) {
        setShowAddUserModal(false);
        setNewUser({
          name: '',
          email: '',
          builderId: '',
          role: ''
        });
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [showAddUserModal]);
  const handleAddUser = () => {
    console.log('Adding new user:', newUser);
    setShowAddUserModal(false);
    setNewUser({
      name: '',
      email: '',
      builderId: '',
      role: ''
    });
  };
  return <>
      <div className="space-y-6 max-w-7xl mx-auto" data-id="element-1026">
        <div className="flex items-center justify-between" data-id="element-1027">
          <div data-id="element-1028">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-1029">Users</h1>
            <p className="text-slate-500" data-id="element-1030">Manage users across all builders</p>
          </div>
          <Button leftIcon={<UserPlus className="h-4 w-4" data-id="element-1032" />} onClick={() => setShowAddUserModal(true)} data-id="element-1031">
            Add User
          </Button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1033">
          <Card data-id="element-1034">
            <div className="p-6" data-id="element-1035">
              <p className="text-sm text-slate-500" data-id="element-1036">Total Users</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-1037">
                {users.length}
              </p>
            </div>
          </Card>
          <Card data-id="element-1038">
            <div className="p-6" data-id="element-1039">
              <p className="text-sm text-slate-500" data-id="element-1040">Active Users</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-1041">
                {users.filter(u => u.status === 'Active').length}
              </p>
            </div>
          </Card>
          <Card data-id="element-1042">
            <div className="p-6" data-id="element-1043">
              <p className="text-sm text-slate-500" data-id="element-1044">Builder Admins</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-1045">
                {users.filter(u => u.role === 'Builder Admin').length}
              </p>
            </div>
          </Card>
          <Card data-id="element-1046">
            <div className="p-6" data-id="element-1047">
              <p className="text-sm text-slate-500" data-id="element-1048">Employees</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-1049">
                {users.filter(u => u.role === 'Builder Employee').length}
              </p>
            </div>
          </Card>
        </div>

        <Card noPadding data-id="element-1050">
          <div className="p-4 border-b border-slate-200 bg-slate-50 rounded-t-xl space-y-4" data-id="element-1051">
            <div className="flex items-center justify-between gap-4" data-id="element-1052">
              <SearchInput className="max-w-sm bg-white" placeholder="Search by name or email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1053" />
              <div className="flex gap-2" data-id="element-1054">
                <Button variant="outline" size="sm" data-id="element-1055">
                  Export
                </Button>
              </div>
            </div>

            {/* Filters */}
            <div className="flex gap-3" data-id="element-1056">
              <select value={selectedBuilder} onChange={e => setSelectedBuilder(e.target.value)} className="px-3 py-1.5 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-1057">
                {builders.map(builder => <option key={builder} value={builder} data-id="element-1058">
                    {builder}
                  </option>)}
              </select>
              <select value={roleFilter} onChange={e => setRoleFilter(e.target.value)} className="px-3 py-1.5 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-1059">
                <option value="All Roles" data-id="element-1060">All Roles</option>
                <option value="Builder Admin" data-id="element-1061">Builder Admin</option>
                <option value="Builder Employee" data-id="element-1062">Builder Employee</option>
              </select>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-1063">
            <table className="w-full text-left text-sm" data-id="element-1064">
              <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-1065">
                <tr data-id="element-1066">
                  <th className="px-6 py-4" data-id="element-1067">User</th>
                  <th className="px-6 py-4" data-id="element-1068">Builder</th>
                  <th className="px-6 py-4" data-id="element-1069">Role</th>
                  <th className="px-6 py-4" data-id="element-1070">Status</th>
                  <th className="px-6 py-4" data-id="element-1071">Last Active</th>
                  <th className="px-6 py-4" data-id="element-1072">Joined</th>
                  <th className="px-6 py-4 text-right" data-id="element-1073">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-1074">
                {filteredUsers.length === 0 ? <tr data-id="element-1075">
                    <td colSpan={7} className="px-6 py-12 text-center text-slate-500" data-id="element-1076">
                      No users found matching your filters
                    </td>
                  </tr> : filteredUsers.map(user => <tr key={user.id} className="hover:bg-slate-50 transition-colors" data-id="element-1077">
                      <td className="px-6 py-4" data-id="element-1078">
                        <div className="flex items-center gap-3" data-id="element-1079">
                          <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 font-semibold text-sm" data-id="element-1080">
                            {user.name.split(' ').map(n => n[0]).join('')}
                          </div>
                          <div data-id="element-1081">
                            <p className="font-medium text-slate-900" data-id="element-1082">
                              {user.name}
                            </p>
                            <p className="text-xs text-slate-500 flex items-center gap-1" data-id="element-1083">
                              <Mail className="h-3 w-3" data-id="element-1084" />
                              {user.email}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-1085">
                        <div className="flex items-center gap-2" data-id="element-1086">
                          <Building2 className="h-4 w-4 text-slate-400" data-id="element-1087" />
                          <span className="text-slate-600" data-id="element-1088">{user.builder}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-1089">
                        <Badge variant="neutral" data-id="element-1090">{user.role}</Badge>
                      </td>
                      <td className="px-6 py-4" data-id="element-1091">
                        <Badge variant={user.status === 'Active' ? 'success' : 'neutral'} data-id="element-1092">
                          {user.status}
                        </Badge>
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-1093">
                        {user.lastActive}
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-1094">
                        <div className="flex items-center gap-1" data-id="element-1095">
                          <Calendar className="h-3 w-3 text-slate-400" data-id="element-1096" />
                          {new Date(user.joinedDate).toLocaleDateString()}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-right" data-id="element-1097">
                        <div className="flex items-center justify-end gap-2" data-id="element-1098">
                          <Button variant="ghost" size="sm" data-id="element-1099">
                            Edit
                          </Button>
                          <Button variant="ghost" size="sm" data-id="element-1100">
                            <MoreHorizontal className="h-4 w-4" data-id="element-1101" />
                          </Button>
                        </div>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Add User Modal */}
      {showAddUserModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1102">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-1103">
            <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-1104">
              <div data-id="element-1105">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-1106">
                  Add New User
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-1107">
                  Create a new user account for a builder
                </p>
              </div>
              <button onClick={() => setShowAddUserModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-1108">
                <X className="h-5 w-5" data-id="element-1109" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-1110">
              <div data-id="element-1111">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1112">
                  Full Name
                </label>
                <input type="text" value={newUser.name} onChange={e => setNewUser({
              ...newUser,
              name: e.target.value
            })} placeholder="e.g., John Smith" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:ring-primary-500 focus:border-primary-500" autoFocus data-id="element-1113" />
              </div>
              <div data-id="element-1114">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1115">
                  Email Address
                </label>
                <input type="email" value={newUser.email} onChange={e => setNewUser({
              ...newUser,
              email: e.target.value
            })} placeholder="e.g., john@excelhomes.com" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:ring-primary-500 focus:border-primary-500" data-id="element-1116" />
              </div>
              <div data-id="element-1117">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1118">
                  Builder Company
                </label>
                <select value={newUser.builderId} onChange={e => setNewUser({
              ...newUser,
              builderId: e.target.value
            })} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-1119">
                  <option value="" data-id="element-1120">Select a builder...</option>
                  {buildersList.map(builder => <option key={builder.id} value={builder.id} data-id="element-1121">
                      {builder.name}
                    </option>)}
                </select>
              </div>
              <div data-id="element-1122">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1123">
                  Role
                </label>
                <select value={newUser.role} onChange={e => setNewUser({
              ...newUser,
              role: e.target.value
            })} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-1124">
                  <option value="" data-id="element-1125">Select a role...</option>
                  <option value="Builder Admin" data-id="element-1126">Builder Admin</option>
                  <option value="Builder Employee" data-id="element-1127">Builder Employee</option>
                </select>
              </div>
              <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-1128">
                <p className="text-xs text-blue-800" data-id="element-1129">
                  An invitation email will be sent to the user with login
                  instructions.
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-1130">
              <Button variant="outline" onClick={() => setShowAddUserModal(false)} data-id="element-1131">
                Cancel
              </Button>
              <Button onClick={handleAddUser} disabled={!newUser.name || !newUser.email || !newUser.builderId || !newUser.role} leftIcon={<UserPlus className="h-4 w-4" data-id="element-1133" />} data-id="element-1132">
                Add User
              </Button>
            </div>
          </div>
        </div>}
    </>;
}